export default "__VITE_ASSET__a9d9e3dd__"